import * as React from 'react'
import { IProviderObject, IProviderProductObject, IServiceProvider } from '../../../types/index'
import ProviderDefaultIcon from '../../icons/ui/ProviderDefault'
import {
  EntityProviderItem,
  EntityProviderItemColLeft,
  EntityProviderItemColRight,
  EntityProviderItemName,
  EntityProviderItemProduct,
  EntityProviders
} from '../../ui/entity/EntityProviders'
import PreloaderCircle from '../../ui/PreloaderCircle'
import ErrorMessage from '../../ui/ErrorMessage'

interface IServiceViewProvidersProps {
  serviceProducts?: IProviderProductObject[]
}

class ServiceViewProviders extends React.Component<IServiceViewProvidersProps> {
  constructor(props: IServiceViewProvidersProps) {
    super(props)
  }

  public render() {
    const { serviceProducts } = this.props
    if (!serviceProducts) {
      return null
    }

    return (
      <div className='ml3'>
        <div className='h4 mt3 bold font-dark-grey'>Products</div>

        {serviceProducts.map(product => (
          <EntityProviderItemProduct key={`product-${product.id}`}>{product.name}</EntityProviderItemProduct>
        ))}
      </div>
    )
  }
}

export default ServiceViewProviders



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewProviders.tsx